// Validator for wellbeing rating fields (0-10)

import { createFieldValueValidator } from '../helpers'

export const wellbeingFieldValueValidator = createFieldValueValidator(10)
